import { render, staticRenderFns } from "./AppointmentDetails.vue?vue&type=template&id=f0e5e43c"
import script from "./AppointmentDetails.vue?vue&type=script&lang=ts"
export * from "./AppointmentDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports